
import { computed, reactive, ref } from "vue";
import validate from "@/utils/validate";
import { visitorService } from "@/service";
import moment from "moment";
import { Toast } from "vant";
import { useRouter } from "vue-router";
import { RouterName } from "@/router";
import { useStore } from "@/store";
import Clipboard from "clipboard";
import chooseVisitorTarget from "@/components/choose-visitor-target/Index.vue";
export default {
  components: { chooseVisitorTarget },
  setup() {
    const store = useStore();
    const userInfo = computed(() => store.state.userInfo);
    const router = useRouter();
    const checkedRadio = ref("1");
    const configInfo = reactive({
      visit_length: "1",
      visit_diy_field: [],
      visit_slas: {
        state: 0,
        content: ""
      }
    });
    const getConfig = async () => {
      try {
        const { data } = await visitorService.configInfo();
        Object.assign(configInfo, data.data);
        if (data.data.visit_reason.length > 0) {
          reasonData.visit_reason = data.data.visit_reason.map((text: string) => ({
            value: text,
            text
          }));
        }
        if (data.data.visit_diy_field.length > 0) {
          data.data.visit_diy_field.forEach((item: any) => {
            formData.visit_diy_field.push({
              title: item.title,
              id: item.id,
              required: item.required === "1",
              value: ""
            });
          });
        }
      } catch (error) {}
    };

    const currentDate = moment();
    const formData = reactive({
      person_lists: [
        {
          key: new Date().getTime(),
          name: "",
          mobile: "",
          email: "",
          car_number: ""
        }
      ],
      person_num: "",
      person_reason: "",
      person_date: "",
      visitor_target_id: "",
      visitor_target_name: "",
      visit_user_name: userInfo.value?.name,
      visit_user_mobile: userInfo.value?.mobile,
      visit_user_email: "",
      visit_diy_field: [] as any[],
      visit_house_id: "",
      visit_house_number: "",
      checked: false,
      showRules: false,
      showPicker: false,
      pickerConfirm(data: any) {
        formData.visitor_target_name = data.name;
        formData.visitor_target_id = data.id;
        formData.showPicker = false;
      },
      houseConfirm(data: any) {
        formData.visit_house_number = data.house_number;
        formData.visit_house_id = data.house_id;
        formData.showPicker = false;
      },
      house_arr:
        userInfo.value?.user_house_arr && userInfo.value?.user_house_arr.length
          ? userInfo.value?.user_house_arr.map((i: any) => ({ ...i, id: i.house_id }))
          : []
    });

    const getTargetList = async () => {
      if (userInfo.value?.user_type == "8") {
        // 如果是住宅人员
        const house = userInfo.value?.user_house_arr || [];
        formData.visit_house_id = house[0].house_id;
        formData.visit_house_number = house[0].house_number;
      } else {
        // 如果是客户
        if (userInfo.value?.user_type == "3") {
          const { data } = await visitorService.visitorTargetLists();

          const stores_id = userInfo.value.stores_id;
          const current = data.data.find((i: any) => i.stores_id == stores_id);
          if (current) {
            formData.visitor_target_id = current.id;
            formData.visitor_target_name = current.name;
          }
        }
      }
    };
    getConfig();
    getTargetList();

    const personReason = ref("0");
    const reasonData = reactive({
      show: false,
      visit_reason: [] as string[],
      person_reason: "",
      pickerConfirm({ text, value }: any) {
        if (value == "其他") reasonData.person_reason = "";
        [formData.person_reason, personReason.value, reasonData.show] = [text, value, false];
      }
    });
    const person_time_start = reactive({
      show: false,
      value: currentDate.toDate(),
      fieldValue: "",
      minDate: currentDate.toDate(),
      filter(type: string, options: string[]) {
        if (type === "minute") {
          if (moment(person_time_start.value).get("hour") === 23) {
            return options.filter(option => Number(option) < 59);
          }
        }
        return options;
      },
      confirm(date: Date) {
        person_time_start.fieldValue = moment(date).format("YYYY-MM-DD HH:mm");
        person_time_end.value = null;
        person_time_end.fieldValue = "";
        person_time_start.show = false;
      }
    });
    const person_time_end = reactive({
      show: false,
      value: null,
      fieldValue: "",
      minDate: computed(() => {
        return moment(person_time_start.fieldValue)
          .add(1, "minute")
          .toDate();
      }),
      maxDate: computed(() => {
        if (configInfo.visit_length === "0") {
          return moment(person_time_start.fieldValue)
            .endOf("days")
            .toDate();
        }
        const date = moment(person_time_start.fieldValue).add(configInfo.visit_length, "minute");
        if (date.isAfter(moment(person_time_start.fieldValue).endOf("days"))) {
          return moment(person_time_start.fieldValue)
            .endOf("days")
            .toDate();
        }
        return date.toDate();
      }),
      confirm(date: Date) {
        person_time_end.fieldValue = moment(date).format("YYYY-MM-DD HH:mm");
        person_time_end.show = false;
      }
    });

    const clickTimeEnd = () => {
      if (!person_time_start.fieldValue) {
        Toast.fail("请先选择来访开始时间");
        return;
      }
      person_time_end.show = true;
    };

    const addPerson = () => {
      formData.person_lists.push({
        key: new Date().getTime(),
        name: "",
        mobile: "",
        email: "",
        car_number: ""
      });
    };
    const deletePerson = (index: number) => {
      formData.person_lists.splice(index, 1);
    };

    const copyData = reactive({
      show: false,
      text: "",
      url: ""
    });
    const onSubmit = async () => {
      // 客户
      if (userInfo.value?.user_type == "3" && !formData.visitor_target_id) {
        Toast.fail("您的所属机构不在被访对象范围内，请联系管理员添加后重试");
        return;
      }
      const o = {};
      if (formData.visit_diy_field.length > 0) {
        formData.visit_diy_field.forEach(item => {
          o[item.id] = item.value;
        });
      }
      try {
        const { data } = await visitorService.add({
          person_lists: checkedRadio.value === "1" ? JSON.stringify(formData.person_lists) : "",
          person_reason: personReason.value == "其他" ? reasonData.person_reason : formData.person_reason,
          person_date: moment(person_time_start.fieldValue).format("YYYY-MM-DD"),
          person_time: `${moment(person_time_start.fieldValue).format("HH:mm")}~${moment(
            person_time_end.fieldValue
          ).format("HH:mm")}`,
          visitor_target_id: formData.visitor_target_id,
          person_num: checkedRadio.value === "1" ? 0 : formData.person_num,
          visit_user_name: formData.visit_user_name,
          visit_user_mobile: formData.visit_user_mobile,
          visit_user_email: formData.visit_user_email,
          visit_diy_field: JSON.stringify(o),
          visit_house_id: formData.visit_house_id,
          visit_house_number: formData.visit_house_number
        });

        if (checkedRadio.value == "2" && data.state == "0" && data.message) {
          copyData.show = true;
          copyData.text = data.message;
          copyData.url = data.data.h5_code;
          // const clipboard = new Clipboard(".copy-view");
          // clipboard.on("success", () => {
          //   Toast.success("复制成功");
          //   clipboard.destroy();
          // });
          // clipboard.on("error", () => {
          //   Toast.success("复制成功");
          //   clipboard.destroy();
          // });
          // Dialog.alert({
          //   message: data.message,
          //   confirmButtonText: "复制信息填写链接",
          //   confirmButtonColor: "#3d6eeb"
          // }).then(() => {
          //   // navigator.clipboard.writeText(window.location.href);
          //   // navigator.clipboard.writeText(
          //   // );
          //   // Toast.success("复制成功");
          //   // router.push({ name: RouterName.VISITOR_RECORD });
          // });
        } else {
          router.push({
            name: RouterName.VISITOR_RECORD
          });
        }
      } catch (error) {}
    };

    const copyCurrentUrl = async () => {
      const clipboard = new Clipboard(".copy-view");
      clipboard.on("success", () => {
        Toast.success("复制成功");
        router.push({ name: RouterName.VISITOR_RECORD });
        clipboard.destroy();
      });
      clipboard.on("error", () => {
        Toast.success("复制失败");
        clipboard.destroy();
      });
    };

    const chooseVisitorTargetShow = ref(false);
    const visitorTargetConfirm = (data: any) => {
      if (data.type === "house") {
        formData.visit_house_id = data.value.id;
        formData.visit_house_number = data.value.place;
        formData.visitor_target_id = "";
        formData.visitor_target_name = data.value.place;
      } else {
        formData.visit_house_id = "";
        formData.visit_house_number = "";
        formData.visitor_target_id = data.value.id;
        formData.visitor_target_name = data.value.name;
      }
    };

    return {
      moment,
      configInfo,
      formData,
      addPerson,
      deletePerson,
      person_time_start,
      person_time_end,
      clickTimeEnd,
      onSubmit,
      validate,
      checkedRadio,
      reasonData,
      personReason,
      userInfo,
      copyData,
      copyCurrentUrl,
      chooseVisitorTargetShow,
      visitorTargetConfirm
    };
  }
};
